const root = window.Shopify?.routes?.root || '/';
let busy = false;
let lastTrigger;
let refreshVersion = 0;
const drawer = () => document.querySelector('[data-rebranding-drawer]');
const page = () => document.querySelector('[data-rb-cart-page]');

function openDrawer(trigger) {
  const dialog = drawer();
  if (!dialog || dialog.open) return;
  lastTrigger = trigger || document.activeElement;
  dialog.showModal();
  dialog.querySelector('#RebrandingDrawerTitle')?.focus({ preventScroll: true });
  document.body.classList.add('rb-cart-open');
  document.querySelectorAll('[data-rb-open-cart]').forEach(button => button.setAttribute('aria-expanded', 'true'));
}

function closeDrawer() {
  drawer()?.close();
}

document.addEventListener('close', event => {
  if (!event.target.matches('[data-rebranding-drawer]')) return;
  document.body.classList.remove('rb-cart-open');
  document.querySelectorAll('[data-rb-open-cart]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
}, true);

function setBusy(value) {
  busy = value;
  [drawer(), page()].filter(Boolean).forEach(area => {
    area.setAttribute('aria-busy', String(value));
    area.querySelectorAll('[data-rb-quantity], [data-rb-quantity-input], [data-rb-remove]').forEach(control => {
      if (value) {
        control.dataset.rbWasDisabled = String(control.disabled);
        control.disabled = true;
      } else if ('rbWasDisabled' in control.dataset) {
        control.disabled = control.dataset.rbWasDisabled === 'true';
        delete control.dataset.rbWasDisabled;
      }
    });
  });
}

function showError(message) {
  document.querySelectorAll('[data-rb-cart-error]').forEach(element => {
    element.textContent = message;
    element.hidden = !message;
  });
}

function sections() {
  return [drawer()?.dataset.rbSection, page()?.dataset.rbSection].filter(Boolean);
}

function applyCart(cart, htmlSections) {
  const active = document.activeElement;
  const key = active?.closest('[data-rb-line]')?.dataset.rbLine;
  const action = active?.dataset.rbQuantity;
  const inputFocused = active?.matches('[data-rb-quantity-input]');
  let needsRefresh = false;
  for (const area of [drawer(), page()].filter(Boolean)) {
    const html = htmlSections?.[area.dataset.rbSection];
    if (!html) { needsRefresh = true; continue; }
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const selector = area.matches('[data-rebranding-drawer]') ? '[data-rb-drawer-content]' : '.rb-cart-shell';
    const current = area.querySelector(selector);
    const updated = documentFragment.querySelector(selector);
    if (current && updated) {
      const scroller = area.querySelector('.rb-cart-drawer__items');
      const scrollTop = scroller?.scrollTop || 0;
      current.replaceWith(updated);
      const newScroller = area.querySelector('.rb-cart-drawer__items');
      if (newScroller) newScroller.scrollTop = scrollTop;
    } else needsRefresh = true;
  }
  document.querySelectorAll('[data-rb-cart-count]').forEach(counter => {
    counter.textContent = `(${cart.item_count})`;
  });
  document.querySelectorAll('.header__cart-counter').forEach(counter => {
    counter.textContent = cart.item_count;
    counter.classList.toggle('hidden', !cart.item_count);
  });
  document.querySelector('#cart-icon-group')?.setAttribute('data-cart-state', cart.item_count ? 'filled' : 'empty');
  if (key && (action || inputFocused)) {
    const area = drawer()?.open ? drawer() : page();
    const selector = action ? `[data-rb-quantity="${action}"]` : '[data-rb-quantity-input]';
    const control = area?.querySelector(`[data-rb-line="${CSS.escape(key)}"] ${selector}`);
    if (control && !control.disabled) control.focus({ preventScroll: true });
    else if (drawer()?.open) drawer().querySelector('[data-rb-close]')?.focus({ preventScroll: true });
  }
  return needsRefresh;
}

async function refreshCart() {
  const version = ++refreshVersion;
  const url = new URL(window.location.href);
  url.searchParams.set('sections', sections().join(','));
  const responses = await Promise.all([fetch(`${root}cart.js`, { cache: 'no-store' }), fetch(url, { cache: 'no-store' })]);
  if (responses.some(response => !response.ok)) throw new Error(drawer()?.dataset.errorMessage || 'Unable to refresh your bag. Please try again.');
  const [cart, html] = await Promise.all(responses.map(response => response.json()));
  if (version === refreshVersion) applyCart(cart, html);
}

async function changeLine(key, quantity) {
  if (busy) return;
  setBusy(true);
  showError('');
  ++refreshVersion;
  try {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: sections(), sections_url: window.location.pathname })
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || cart.message);
    if (applyCart(cart, cart.sections)) await refreshCart();
    document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, cart, data: { source: 'rebranding-cart', itemCount: cart.item_count } } }));
  } catch (error) {
    showError(error.message);
    document.querySelectorAll('[data-rb-quantity-input]').forEach(input => { input.value = input.defaultValue; });
  } finally {
    setBusy(false);
  }
}

document.addEventListener('click', event => {
  const opener = event.target.closest('[data-rb-open-cart]');
  if (opener) { event.preventDefault(); openDrawer(opener); return; }
  const closer = event.target.closest('[data-rb-close]');
  if (closer) { event.preventDefault(); closeDrawer(); return; }
  if (event.target === drawer()) {
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDrawer();
    return;
  }
  const control = event.target.closest('[data-rb-quantity], [data-rb-remove]');
  if (!control) return;
  const item = control.closest('[data-rb-line]');
  if (!item) return;
  const input = item.querySelector('[data-rb-quantity-input]');
  const quantity = control.hasAttribute('data-rb-remove') ? 0 : Number(input.value) + (control.dataset.rbQuantity === 'plus' ? 1 : -1) * Number(input.step || 1);
  changeLine(item.dataset.rbLine, quantity);
});

document.addEventListener('change', event => {
  if (!event.target.matches('[data-rb-quantity-input]')) return;
  const input = event.target;
  if (!input.checkValidity() || !Number.isInteger(Number(input.value))) {
    input.reportValidity();
    input.value = input.defaultValue;
    return;
  }
  changeLine(input.closest('[data-rb-line]').dataset.rbLine, Number(input.value));
});

document.addEventListener('cart:update', async event => {
  const data = event.detail?.data;
  if (data?.source === 'rebranding-cart' || data?.didError) return;
  try {
    await refreshCart();
    if (['product-form-component', 'wish-list-product-card'].includes(data?.source)) openDrawer();
  } catch (error) { showError(error.message); }
});
